"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
function isTaskComment(object) {
    return checkTaskComment(object).fulfilled;
}
exports.isTaskComment = isTaskComment;
function checkTaskComment(object, options = { ignoreSuperfluousObjectProperties: true }) {
    return __1.check(object, __1.hasString("id"), __1.hasString("taskId"), __1.hasString("userId"), __1.hasString("content"), __1.hasNumber("createdTimestamp").integer()).withOptions(options).explain();
}
exports.checkTaskComment = checkTaskComment;
//# sourceMappingURL=TaskComment.js.map